module.exports = __webpack_public_path__ + "img/Flag_of_Germany.85f98c37.svg";